export default __webpack_public_path__ + "static/media/chevron-arrow-up.06187a2c.svg";